<template>
    <div>
        <van-sticky
            type="primary"
            v-if="isWechat"
        >
            <van-nav-bar
                title="商品详情"
                left-text="返回"
                left-arrow
                @click-left="onGoBack"
            />
        </van-sticky>
        <!-- 品牌相关背景图 -->
        <van-image
            class="sku__brand-background-img"
            sticky
            height='200'
            :src="mainPic"
            fit='cover'
        />
        <!-- 卡券信息 -->
        <cell-card class="sku__account-info-block-wrapper">
            <van-row class="sku__account-info-block">
                <van-row class="sku__account-info-title">{{skuName}}</van-row>
                <van-row class="sku__account-price-info-wrapper"
                    type="flex"
                    align="bottom"
                    justify="center"
                    gutter="8"
                >
                    <span class="sku__account-price-currency">¥</span>
                    <span class="sku__account-price">{{discPriceYuan}}</span>
                    <span class="sku__account-raw-price">原价 ¥ {{rawPriceYuan}}</span>
                </van-row>
                <van-row>
                    <div class="sku__account-divider-dashed"/>
                </van-row>
                <van-row class="sku__account-valid-time">
                    质保期：购买后{{guaranteeHour}}小时内
                </van-row>
            </van-row>
        </cell-card>
        <!-- message config -->
        <van-form v-if="messageConfigs" style="background-color: 'white'; margin: 8px 8px 0 8px; border-radius: 8PX; overflow: hidden">
            <template v-for='item in messageConfigs'>
                <!-- text -->
                <template v-if='item.type == "TEXT"'>
                    <van-field
                        :key="item.id"
                        type="text"
                        v-model="item.val"
                        :label='item.name'
                        label-width="6.2em"
                        :placeholder="item.placeholder"
                        :border="false"
                    />
                    <van-field
                        v-if="item.doubleCheck"
                        :key="`${item.id}-doublecheck`"
                        v-model="item.doubleVal"
                        type="text"
                        :label="item.name"
                        label-width="6.2em"
                        placeholder="请再次输入"
                        :border="false"
                    />
                </template>
                <!-- radio -->
                <template v-if='item.type == "RADIO"'>
                    <van-radio-group v-model="item.val" :key="item.id">
                        <van-cell-group>
                            <van-cell
                                v-for="option in item.options"
                                :key="option.value" 
                                :title="option.name"
                            >
                                <template #right-icon>
                                    <van-radio :name="option.name" checked-color="#17161c"/>
                                </template>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>
                </template>
            </template>
        </van-form>
        <!-- 使用说明 -->
         <cell-card
            class="sku__account-info-desc-wrapper"
            title="使用说明"
        >
            <div
                class="sku__account-info-desc"
                v-html="instruction"     
            />
        </cell-card>
        <!-- 底部支付按钮 -->
        <div class="sku__goods-action-placeholder"></div>
        <van-goods-action safe-area-inset-bottom class="sku__goods-action">
            <van-goods-action-icon icon="chat-o" text="客服"/>
              <van-goods-action-button
                    :loading="loading"
                    type="danger"
                    text="立即购买"
                    @click="onSubmit"
                />
        </van-goods-action>
        <!-- Skeleton -->
        <div class="skeleton-wrapper" v-if="false">
            <van-row class="skeleton__banner-wrapper">
                <van-row class="skeleton__banner"></van-row>
            </van-row>
            <!-- 商品信息块 -->
            <van-row class="skeleton__sku-desc-wrapper">
                <van-row class="skeleton__sku-name"></van-row>
                <van-row class="skeleton__sku-price"></van-row>
                <van-row class="skeleton__sku-guarantee-time"></van-row>
            </van-row>
            <!-- 商品说明块 -->
            <van-row class="skeleton__sku-instruction-wrapper">
                <van-row class="skeleton__sku-instruction-title"/>
                <van-row class="skeleton__sku-instruction-item-wrapper">
                    <van-row class="skeleton__sku-instruction-item skeleton__placeholder-width-100"/>
                    <van-row class="skeleton__sku-instruction-item skeleton__placeholder-width-85"/>
                    <van-row class="skeleton__sku-instruction-item skeleton__placeholder-width-100"/>
                    <van-row class="skeleton__sku-instruction-item skeleton__placeholder-width-100"/>
                    <van-row class="skeleton__sku-instruction-item skeleton__placeholder-width-85"/>
                    <van-row class="skeleton__sku-instruction-item skeleton__placeholder-width-100"/>
                    <van-row class="skeleton__sku-instruction-item skeleton__placeholder-width-100"/>
                    <van-row class="skeleton__sku-instruction-item skeleton__placeholder-width-100"/>
                    <van-row class="skeleton__sku-instruction-item skeleton__placeholder-width-65"/>
                </van-row>
            </van-row>
        </div>
    </div>
</template>

<script>
    import CellCard from "@/components/CellCard.vue";
    import {Image, SubmitBar, Row, Col, GoodsAction, GoodsActionIcon, GoodsActionButton,
        Dialog, CouponCell, CouponList, NavBar, Sticky, Field, 
        Form, RadioGroup, Radio, Cell, CellGroup } from 'vant';
    import {navMixins, wechatMixins} from "@/mixins.js";
    import request from "@/utils/request.js";
    import qs from "qs";
    import wechat from "@/utils/wechat.js";


    export default {
        name: 'sku',
        mixins: [navMixins, wechatMixins],
        components: {
            [Image.name]: Image,
            [CellCard.name]: CellCard,
            [SubmitBar.name]: SubmitBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [Dialog.Component.name]: Dialog.Component,
            [CouponCell.name]: CouponCell,
            [CouponList.name]: CouponList,
            [GoodsAction.name]: GoodsAction,
            [GoodsActionIcon.name]: GoodsActionIcon,
            [GoodsActionButton.name]: GoodsActionButton,
            [NavBar.name]: NavBar,
            [Sticky.name]: Sticky,
            [Field.name]: Field,
            [Form.name]: Form,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup
        },
        data() {
            return {
                showDialog: true,
                skuName: undefined,
                skuCode: undefined,
                discPrice: undefined,
                rawPrice: undefined,
                guaranteeHour: undefined,
                mainPic: undefined,
                instruction: undefined,
                goodsId: undefined,
                goodsType: undefined,
                messageConfigs: undefined,
                loading: true
            };
        },
        computed: {
            discPriceYuan: function() {
                return (this.discPrice / 100).toFixed(2);
            },
            rawPriceYuan: function() {
                return (this.rawPrice / 100).toFixed(2);
            }
        },
        created() {
        },
        mounted() {
            this.loadSku();
        },
        methods: {
            async loadSku() {
                const goodsId = this.$route.params.goodsId;
                this.goodsId = goodsId;
                const queryStr = qs.stringify({
                    goodsId
                });

                const {response, data} = await request.get(`/customer/goods/loadGoods?${queryStr}`);
                if (response.ok) {
                    this.skuName = data.skuName,
                    this.skuCode = data.skuCode,
                    this.discPrice = data.discPrice,
                    this.rawPrice = data.rawPrice,
                    this.guaranteeHour = data.guaranteeHour,
                    this.mainPic = data.mainPic,
                    this.instruction = data.instruction
                    this.goodsType = data.goodsType;
                    this.messageConfigs = data.messageConfigs?.map(messageConfig => {
                        const doubleMetaKey = `${messageConfig.metaKey}DoubleCheck`;
                        return {
                            ...messageConfig,
                            doubleMetaKey: doubleMetaKey
                        };
                    });
                }

                this.loading = false;
            },
            isAccountSeriesGoods(goodsType) {

                switch(goodsType) {
                    case "BARCODE_128":
                    case "QR_CODE": 
                    case "ANP": 
                    case "ACCOUNT_PSW":
                    case "BARCODE_128_QR_CODE":
                    case "URL":
                        return true;
                default:
                    return false;
                    // case "DIRECT":
                    // case "RIGHTS_GOODS":
                    // case "TASK_RECHARGE":
                    // case "TASK_PURCHASE":
                }
            },
            async onSubmit() {
                // 先校验输入参数
                 if (this.messageConfigs && this.messageConfigs.length) {
                    for (const config of this.messageConfigs) {
                        // 校验必传
                        if (config.required && !config.val) {
                            this.$notify({
                                type: 'warning',
                                message: `请输入${config.name}字段`
                            });
                            return;
                        }
                        // 校验二次输入
                        if (config.doubleCheck && config.val !== config.doubleVal) {
                            this.$notify({
                                type: 'warning',
                                message: `输入${config.name}字段不一致`
                            });
                            return;
                        }
                    }
                }
                // 如果是卡号类商品，则跳转到submit页面；否则直接就当前页面直接拉起支付
                if (this.isAccountSeriesGoods(this.goodsType)) {
                    this.$router.push(`/submit-order?skuCode=${this.skuCode}&num=1`);
                } else {
                    this.loading = true; 
                     try {
                        const orderResult = await request.post('/customer/order/createOrder', {
                            data: {
                                orderPrice: this.discPrice,
                                itemList: [{
                                    skuCode: this.skuCode,
                                    count: 1,
                                    skuPrice: this.discPrice,
                                    couponNo: undefined,
                                    messageList: this.messageConfigs && this.messageConfigs.map(config => {
                                            return {
                                                id: config.id,
                                                key: config.metaKey,
                                                value: config.val
                                            };
                                        })
                                }]
                            }
                        });
                        // 创建支付单
                        const orderNo = orderResult.data.orderNo;

                        const {data} = await request.post('/customer/payment/createPayOrder', {
                            data: {
                                orderNo,
                                payType: "WECHAT_JSAPI"
                            }
                        });
                        if (this.orderPrice != 0) {
                            const paymentParam = JSON.parse(data.paymentParam);
                            // 拉起Wap支付
                            wechat.triggerWapPayment(paymentParam.appId,
                                                    paymentParam.timeStamp,
                                                    paymentParam.nonceStr,
                                                    paymentParam.package,
                                                    paymentParam.signType,
                                                    paymentParam.paySign, () => {
                                                        this.$router.push(`/result/${orderNo}`);
                                                    });
                        } else {
                        this.$router.push(`/result/${orderNo}`); 
                        }

                    } finally {
                        this.loading = false;
                    }
                    
                }
            }
        }
    };
</script>

<style lang="less">
@import "@/style/base.less";

.sku__brand-background-img {
    position: absolute;
    top: 0px;
}

.sku__account-info-block-wrapper {
    margin-top: 150px;
}

.sku__account-info-block {
    padding: 8px;
    text-align: center;
}

.sku__account-info-title {
    margin-top: 16px;
    font-size: 22px;
    font-weight: @font-weight-title;
    color: @font-color-title;
    line-height: 30px;
}

.sku__account-price-currency {
    color: @color-price;
    font-size: @font-size-mini;
}

.sku__account-price-info-wrapper {
    width: 100%;
    margin-top: 8px;
}

.sku__account-price {
    color: @color-price;
    font-size: 22px;
    font-weight: @font-weight-price;
    line-height: 30px;
    margin: 0 8px;
}

.sku__account-raw-price {
    text-decoration: line-through;
    color: @font-color-secondary;
    font-size: @font-size-mini;
}

.sku__account-divider-dashed {
    border-bottom: 1px dashed #ebedf0;
    margin: 8px 0;
}

.sku__account-valid-time {
    font-size: @font-size-mini;
    color: @font-color-secondary;
    line-height: @line-height-mini;
}

.sku__account-info-desc-wrapper {
    margin-bottom: 16px;
}

.sku__account-info-desc {
    padding: 0 16px 16px 16px;
    
}
.sku__goods-action-placeholder {
    height: calc(constant(safe-area-inset-bottom) + 50px);
    height: calc(env(safe-area-inset-bottom) + 50px);
}

.sku__goods-action {
    .van-goods-action-button--danger {
        background: @color-theme;
        color: @color-vice;
    }
}

// Skeleton
.skeleton-wrapper {
    position: absolute;
    top: 0px;
    width: 100%;
    box-sizing: border-box;
    height: 100vh;
    background-color: @color-skeleton-background;
    padding: 8px;
}

.skeleton__banner-wrapper {
    width: 100%;
    box-sizing: border-box;
}

.skeleton__banner {
    background-color: @color-skeleton-placeholder;
    border-radius: @border-radius-small;
    height: 150px;
}

.skeleton__sku-desc-wrapper {
    text-align: center;
}

.skeleton__sku-name {
    background-color: @color-skeleton-placeholder;
    border-radius: @border-radius-small;
    width: 55%;
    height: 16px;
    margin: 16px auto 0 auto;
}

.skeleton__sku-price {
   margin: 8px auto 0 auto;
   height: 16px;
   background-color: @color-skeleton-placeholder;
   width: 25%;
   border-radius: @border-radius-small;
}

.skeleton__sku-guarantee-time {
    margin: 8px auto 0 auto;
    width: 35%;
    background-color: @color-skeleton-placeholder;
    height: 16px;
}

.skeleton__sku-instruction-wrapper {
    margin-top: 40px;
    padding: 0 24px;
}

.skeleton__sku-instruction-title {
    height: 16px;
    background-color: @color-skeleton-placeholder;
    width: 35%;
    border-radius: @border-radius-small;
}

.skeleton__placeholder-width-85 {
    width: 85%;
}

.skeleton__placeholder-width-100 {
    width: 100%;
}

.skeleton__placeholder-width-65 {
    width: 65%;
}

.skeleton__sku-instruction-item-wrapper {
    margin-top: 16px;
}

.skeleton__sku-instruction-item {
    height: 16px;
    background-color: @color-skeleton-placeholder;
    border-radius: @border-radius-small;
    margin-top: 8px;
}

// Skeleton
</style>
